import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_upsells_on_tai_chi~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsells_on_tai_chi'),
				},
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_upsells_on_tai_chi~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsells_on_tai_chi'),
				},
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_upsells_on_tai_chi~1
			upsell: {
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsells_on_tai_chi'),
				},
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_upsells_on_tai_chi~1
			upsell: {
				experiment: {
					'upsell-activity-f': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsells_on_tai_chi'),
				},
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_upsells_on_tai_chi~1
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsells_on_tai_chi'),
				},
			},
		},
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_upsells_on_tai_chi~1
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsells_on_tai_chi'),
				},
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_upsells_on_tai_chi~1
			upsell: {
				experiment: {
					'upsell-activity-m': () =>
						import(/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_upsells_on_tai_chi'),
				},
			},
		},
	},
]

export default config
